import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { __API_URL__ } from "../SERVER_URL";
import { showApiErrorToast } from "../utils/helpers";

const fetchVisitSurveys = async ({ visitId, stepId }) => {
  const token = localStorage.getItem("token");

  const params = new URLSearchParams();
  if (stepId) params.append("step_id", stepId);

  const res = await axios.get(
    `${__API_URL__}/api/photos/visits/${visitId}/surveys/?${params.toString()}`,
    {
      headers: {
        Authorization: `Token ${token}`,
      },
    }
  );

  return res.data;
};

const useGetVisitSurveys = ({ visitId, stepId, enabled = true }) => {
  return useQuery({
    queryKey: ["visit_surveys", visitId, stepId],
    queryFn: () => fetchVisitSurveys({ visitId, stepId }),
    enabled: enabled && Boolean(visitId),
    onError: (error) => {
      showApiErrorToast(error, "Failed to load visit surveys");
    },
  });
};

export default useGetVisitSurveys;
